<terra-unit-create-bank-account-failed *ngIf="isCreateFailed$ | async else notFailed" [originUrl]="originUrl$ | async">
</terra-unit-create-bank-account-failed>

<ng-template #notFailed>
  <section class="page-heading" *ngIf="{
    originUrl: originUrl$ | async,
    processingSubmit: processingSubmit$ | async
  } as headerContext">

    <a class="close-button" [ngClass]="{'hidden': headerContext.processingSubmit}" mat-icon-button type="button"
       [routerLink]="headerContext.originUrl">
      <mat-icon class="notranslate">close</mat-icon>
    </a>

    <h1>{{ userShouldApprove ? 'Approve CRE Bank Account' : 'Opening of Bank Account is in progress' }} </h1>
    <h2 class="page-sub-header">
      <ng-container *ngIf="userShouldApprove else inApprovalProcess">
        {{ account.createdByClientDetails?.firstName }} {{ account.createdByClientDetails?.lastName }}
        invited you to review and approve<br>
        the following details in order to open a new CRE bank account.
      </ng-container>
      <ng-template #inApprovalProcess>
        Approval request has beend sent to the following<br>
        signers and waiting for their approval.
      </ng-template>
    </h2>

    <mat-icon *ngIf="!userShouldApprove" class="notranslate pending-icon" svgIcon="pending"></mat-icon>
  </section>

  <terra-loader *ngIf="processingSubmit$ | async" class="submit-loader"></terra-loader>

  <ng-container *ngIf="!(processingSubmit$ | async)">
    <section class="account-details-section">
      <h2 class="section-title">Account Details</h2>
      <div class="section-content">
        <div class="details-list">

          <div class="column">
            <div class="item-content">
              <mat-icon class="icon-with-background notranslate">paid</mat-icon>
              <span>
                <label>Nickname: </label>{{account.accountNickname}}
              </span>
            </div>
            <div class="item-content">
              <mat-icon class="icon-with-background notranslate">work</mat-icon>
              <span>
                <label>Type: </label>{{account.accountType | enumString : UnitAccountType}}
              </span>
            </div>
          </div>
          <div class="column" *ngIf="account.unitApplication.parentType === UnitApplicationParentType.Holding">
            <div class="item-content">
              <mat-icon class="icon-with-background notranslate">location_city</mat-icon>
              <span>
                <label>Asset/Fund: </label>{{account.unitApplication?.holding?.name}}
              </span>
            </div>
          </div>
        </div>

        <div class="signers">
          <mat-icon class="signers-icon icon-with-background notranslate">edit</mat-icon>
          <label>Approvers</label>
          <ul class="signers-list">
            <li class="signer-item" *ngFor="let signature of account.signatureList?.signatures" [class.awaiting-approval]="!signature.signedOnDate">
              <span class="name">{{ signature.firstName + ' ' + signature.lastName | truncate }}</span>
              <span class="status-details">
                <mat-icon class="status-icon notranslate">
                  {{ signature.signedOnDate ? 'task_alt' : 'radio_button_unchecked' }}
                </mat-icon>
                <span class="status-name">
                  {{ signature.signedOnDate ? 'Approved' : 'Awaiting Approval'}}
                </span>
                <span class="sign-date" *ngIf="signature.signedOnDate">{{ signature.signedOnDate | date : 'mediumDate'}}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="account-fees-section" *ngIf="false && userShouldApprove">
      <h2 class="section-title">Account Fees</h2>
      <p class="description">
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quidem officiis, vero libero at veniam quasi facere expedita, <br>
        accusamus, necessitatibus sit voluptatibus rerum odit. Assumenda neque ratione cupiditate commodi nostrum possimus.
      </p>
      <terra-unit-bank-account-fees-table [fees]="fees$ | async"></terra-unit-bank-account-fees-table>
    </section>

    <ng-container *ngIf="userShouldApprove">
      <form id="bankAccountForm" [formGroup]="pageForm" *ngIf="{
        processingSubmit: processingSubmit$ | async
        } as formContext" (ngSubmit)="approve()">

        <section class="agreements-section">
          <h4>Check these to indicate that you have read and agree to the following:</h4>
          <div class="agreements-section-checkbox">
            <mat-checkbox formControlName="depositAgreement" color="primary">Deposit Agreement</mat-checkbox>
            <mat-error *ngIf="pageForm.get('depositAgreement').hasError('required') && (isSubmitAttempt$ | async)" class="error-message">
              Please agree to the deposit agreement
            </mat-error>
          </div>
          <p>
            <mat-checkbox formControlName="termsOfServiceAgreement" color="primary">Terms of Service</mat-checkbox>
            <mat-error *ngIf="pageForm.get('termsOfServiceAgreement').hasError('required') && (isSubmitAttempt$ | async)" class="error-message">
              Please agree to the Terms of Service
            </mat-error>
          </p>
        </section>

        <section class="form-footer">
          <button type="submit" form="bankAccountForm"
                  mat-flat-button color="primary" [disabled]="formContext.processingSubmit" class="cov-button continue-button">
            Approve Bank Account
          </button>
          <a mat-stroked-button [disabled]="formContext.processingSubmit" [routerLink]="originUrl$ | async" class="cancel-button cov-button">
            Cancel
          </a>
        </section>
      </form>
    </ng-container>
  </ng-container>
</ng-template>
